import { AddressesUrlParams } from "../parameters/addresses-url-params";

export let MENU_ITEM = {
  "Banco de Alimentos": {
    title: "Banco de Alimentos",    
    path:
      AddressesUrlParams.PAGE_DONACIONES
  }  
};



// WEBPACK FOOTER //
// ./src/app/pages/menu.ts